import React from 'react';

import Card from "@mui/joy/Card";
import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";
import CardContent from "@mui/joy/CardContent";
import {Accordion, AccordionDetails, AccordionSummary, CardOverflow, CircularProgress, Stack} from "@mui/joy";
import Divider from "@mui/joy/Divider";
import Link from "@mui/joy/Link";

// components
import TaskCreateModal from "../Task/TaskCreateModal";
import EstimationPhaseActive from "./EstimationPhaseActive";
import BaseApi from "../../utils/BaseApi";
import TaskCard from "../Cards/TaskCard";
import CommentSidebar from "../Comment/CommentSidebar";
import CommonEditModal from "../Common/CommonEditModal";

// icons
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';


class EstimationPhaseCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phase: this.props.phase,
            tasks: null,
            formFields: null,
            deleted: false,
        };
    }

    async componentDidMount() {
        await this.retrieveTasks();
    }

    async process() {
        this.setState(
            {
                phase: null,
            }
        );
        const url = `estimation_phase/${this.props.phase.id}/`;
        const api = new BaseApi();
        let response = await api.get(
            url,
            {}
        );
        this.setState(
            {
                phase: response.data,
            }
        )
    }

    async copy() {
        const url = `estimation_phase/${this.props.phase.id}/copy/`;
        const api = new BaseApi();
        await api.get(url, {});
        await this.props.callBack();
    }

    async destroy() {
        const url = `estimation_phase/${this.props.phase.id}/`;
        const api = new BaseApi();
        await api.delete(url, {});
        this.setState({
            deleted: true,
        })
    }

    async moveTop() {
        const url = `estimation_phase/${this.props.phase.id}/`;
        const api = new BaseApi();
        const data = {
            order: 1
        };
        await api.patch(
            url,
            data
        );
        await this.props.callBack();
    }

    async moveUp() {
        const url = `estimation_phase/${this.props.phase.id}/move_up/`;
        const api = new BaseApi();
        await api.get(url, {});
        await this.props.callBack();
    }

    async moveDown() {
        const url = `estimation_phase/${this.props.phase.id}/move_down/`;
        const api = new BaseApi();
        await api.get(url, {});
        await this.props.callBack();
    }

    async moveBottom() {
        const url = `estimation_phase/${this.props.phase.id}/move_bottom/`;
        const api = new BaseApi();
        await api.get(url, {});
        await this.props.callBack();
    }


    async retrieveTasks() {
        const url = `task/`;
        const api = new BaseApi();
        const params = {
            phase: this.props.phase.id
        };
        let response = await api.get(
            url,
            params,
        );
        this.setState(
            {
                tasks: response.data.results
            }
        );
    }

    render() {
        if (this.state.deleted) {
            return (
                <Card
                    variant={'soft'}
                    sx={{
                        mb: 2,
                    }}
                >
                    <CardContent>
                        <Typography
                            color={'danger'}
                        >
                            <DeleteIcon sx={{mr: 1}}/>
                            Удалено
                        </Typography>
                    </CardContent>
                </Card>
            )
        }
        if (!this.state.phase) {
            return (<CircularProgress/>)
        }
        if (!this.state.tasks) {
            return (<CircularProgress/>)
        }
        return (
            <Card
                variant={'soft'}
                sx={{
                    mb: 1,
                    mt: 1,
                }}
                orientation={'horizontal'}
            >
                <CardContent>
                    <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Stack
                            spacing={1}
                        >
                            <Stack
                                direction={'row'}
                                spacing={1}
                                useFlexGap
                                sx={{ flexWrap: 'wrap' }}
                            >
                                <EstimationPhaseActive
                                    phase={this.state.phase}
                                />
                                <Chip
                                    size={'sm'}
                                    variant={'solid'}
                                    color={'neutral'}
                                >
                                    #{this.state.phase.id}
                                </Chip>
                                <Stack
                                    direction={'row'}
                                    sx={{
                                        position: 'relative'
                                    }}
                                >
                                    <Chip
                                        size={'sm'}
                                        color={'primary'}
                                    >
                                        {this.state.phase.phase_type.title}
                                    </Chip>
                                    <CommonEditModal
                                        overlay={true}
                                        fields={
                                            [
                                                'phase_type',
                                            ]
                                        }
                                        baseUrl={'estimation_phase'}
                                        obj={{
                                            id: this.state.phase.id,
                                            phase_type: this.state.phase.phase_type.id,
                                        }}
                                        callBack={this.process.bind(this)}
                                    />
                                </Stack>
                                <Stack
                                    direction={'row'}
                                    sx={{
                                        position: 'relative'
                                    }}
                                >
                                    <Typography level={'title-md'}>
                                        {this.state.phase.title}
                                    </Typography>
                                    <CommonEditModal
                                        overlay={true}
                                        fields={
                                            [
                                                'title',
                                            ]
                                        }
                                        baseUrl={'estimation_phase'}
                                        obj={this.state.phase}
                                        callBack={this.process.bind(this)}
                                    />
                                </Stack>
                            </Stack>
                            <Stack
                                direction={'row'}
                                sx={{
                                    position: 'relative',
                                    minHeight: '10px',
                                    minWidth: '100px',
                                }}
                            >
                                <div dangerouslySetInnerHTML={{__html: this.state.phase.desc}}/>
                                <CommonEditModal
                                        overlay={true}
                                        fields={
                                            [
                                                'desc',
                                            ]
                                        }
                                        baseUrl={'estimation_phase'}
                                        obj={this.state.phase}
                                        callBack={this.process.bind(this)}
                                    />
                            </Stack>
                        </Stack>
                        <Stack
                            spacing={1}
                        >
                            <Stack
                                direction={'row'}
                                spacing={1}
                                useFlexGap
                                sx={{ flexWrap: 'wrap' }}
                            >
                                <Stack
                                    direction={'row'}
                                    spacing={1}
                                    sx={{
                                        position: 'relative'
                                    }}
                                >

                                    <Chip
                                        color={'primary'}
                                        size={'sm'}
                                    >
                                        {this.state.phase.estimation_minimum}
                                    </Chip>
                                    <Chip
                                        color={'primary'}
                                        size={'sm'}
                                    >
                                        {this.state.phase.estimation_normal}
                                    </Chip>
                                    <Chip
                                        color={'primary'}
                                        size={'sm'}
                                    >
                                        {this.state.phase.estimation_maximum}
                                    </Chip>
                                    <CommonEditModal
                                        overlay={true}
                                        fields={
                                            [
                                                'estimation_minimum',
                                                'estimation_normal',
                                                'estimation_maximum',
                                            ]
                                        }
                                        baseUrl={'estimation_phase'}
                                        obj={this.state.phase}
                                        callBack={this.process.bind(this)}
                                    />
                                </Stack>
                                <Chip
                                    color={'warning'}
                                    size={'sm'}
                                >
                                    {this.state.phase.real_workload}
                                </Chip>
                            </Stack>
                            <Stack
                                direction={'row'}
                                sx={{
                                    position: 'relative'
                                }}
                            >
                                <Chip
                                    color={'primary'}
                                    size={'sm'}
                                >
                                    {this.state.phase.workers + ' исп.'}
                                </Chip>
                                <CommonEditModal
                                        overlay={true}
                                        fields={
                                            [
                                                'workers',
                                            ]
                                        }
                                        baseUrl={'estimation_phase'}
                                        obj={this.state.phase}
                                        callBack={this.process.bind(this)}
                                    />
                            </Stack>

                        </Stack>
                    </Stack>
                    <Card
                        size={'sm'}
                        variant={'plain'}
                    >
                        <Accordion
                            size="sm"

                        >
                            <AccordionSummary>
                                <Typography
                                    level={'title-md'}
                                >
                                    Задачи и комментарии
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Divider
                                    sx={{
                                        my: 2
                                    }}
                                />
                                <Stack
                                    direction={'row'}
                                    spacing={2}
                                    sx={{
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        height: '650px'
                                    }}
                                >
                                    <Stack
                                        spacing={1}
                                        sx={{
                                            width: '48%',
                                            height: '100%',
                                            overflowY: 'scroll'
                                        }}
                                    >
                                        <TaskCreateModal
                                            account={this.state.phase.opportunity.account.id}
                                            accountObj={this.state.phase.opportunity.account}
                                            opportunity={this.state.phase.opportunity.id}
                                            opportunityObj={this.state.phase.opportunity}
                                            phase={this.state.phase.id}
                                            phaseObj={this.state.phase}
                                            activeStep={4}
                                            lockedSteps={[0, 1, 2, 3]}
                                            callBack={this.retrieveTasks.bind(this)}
                                            buttonLabel={'Добавить задачу'}
                                            buttonColor={'neutral'}
                                        />
                                        {this.state.tasks.map(each => {
                                            return (
                                                <TaskCard
                                                    hideOpportunity={true}
                                                    hidePhase={true}
                                                    task={each}
                                                    callBack={this.retrieveTasks.bind(this)}
                                                />
                                            )
                                        })}

                                    </Stack>
                                    <Divider
                                        orientation={'vertical'}
                                    />
                                    <Stack
                                        spacing={1}
                                        sx={{
                                            width: '48%',
                                            height: '100%'
                                        }}
                                    >
                                        <CommentSidebar
                                            appName={'EstimationPhase'}
                                            appId={this.state.phase.id}
                                        />
                                    </Stack>
                                </Stack>
                            </AccordionDetails>
                        </Accordion>
                    </Card>
                </CardContent>
                <CardOverflow
                    variant={'soft'}
                    color={'primary'}
                    sx={{
                        pl: 1
                    }}
                >
                    <Stack
                        spacing={1}
                    >
                        <Link
                            level="body-xs"
                            color={'warning'}
                            onClick={this.copy.bind(this)}
                        >
                            <ContentCopyIcon sx={{mr: 1}}/>
                        </Link>
                        <Link
                            level="body-xs"
                            color={'danger'}
                            onClick={this.destroy.bind(this)}
                        >
                            <DeleteIcon sx={{mr: 1}}/>
                        </Link>
                        <Divider/>
                        <KeyboardDoubleArrowUpIcon
                            sx={{cursor: 'pointer'}}
                            onClick={this.moveTop.bind(this)}
                        />
                        <KeyboardArrowUpIcon
                            sx={{cursor: 'pointer'}}
                            onClick={this.moveUp.bind(this)}
                        />
                        <KeyboardArrowDownIcon
                            sx={{cursor: 'pointer'}}
                            onClick={this.moveDown.bind(this)}
                        />
                        <KeyboardDoubleArrowDownIcon
                            sx={{cursor: 'pointer'}}
                            onClick={this.moveBottom.bind(this)}
                        />
                    </Stack>
                </CardOverflow>
            </Card>
        )
    }
}

export default EstimationPhaseCard